"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRefreshTokenBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateRefreshTokenBody = (0, validation_1.properties)({
    refreshToken: (0, validation_1.text)(),
});
//# sourceMappingURL=RefreshTokenBody.js.map